import { usePagination } from 'shared/route-query/hooks/use-pagination'
import { useNotifications } from '../hooks/use-notifications'
import { useNotificationsActions } from '../hooks/use-notification-actions'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import NotificationEmptyList from './notification-empty-list'
import { NotificationItem } from './notification-item'
import NotificationsListSkeleton from './notifications-list-skeleton'
import { DoubleCheckmarkIcon, SettingsIcon, ThinArrowRightIcon } from '@systemeio/ui'
import { twMerge } from 'tailwind-merge'

const defaultFilter = {
  onlyUnRead: false,
}

export const NotificationsMenuContent = ({ className }: { className?: string }) => {
  const { t } = useLocoTranslation()

  const { pagination } = usePagination(true)
  const { notifications } = useNotifications({
    limit: 3,
    pagination,
    filter: defaultFilter,
  })
  const { markAllNotificationsAsRead } = useNotificationsActions()

  return (
    <div
      className={twMerge(
        'bg-background-secondary flex w-full flex-col py-4 text-sm shadow-lg',
        className,
      )}
    >
      <div className="flex flex-row justify-between px-6">
        <h4 className="text-text-primary text-[18px]">{t('dashboard.notifications.title')}</h4>
        <div className="stroke-text-primary hover:stroke-brand-primary text-text-primary hover:text-brand-primary inline-flex flex-row items-baseline gap-1 transition">
          <DoubleCheckmarkIcon />
          <span className="cursor-pointer" onClick={markAllNotificationsAsRead}>
            {t('dashboard.notifications.mark_all_read')}
          </span>
        </div>
      </div>
      {notifications === undefined ? (
        <NotificationsListSkeleton />
      ) : notifications.items.length > 0 ? (
        notifications.items.map(notification => (
          <NotificationItem key={notification.id} notification={notification} />
        ))
      ) : (
        <NotificationEmptyList />
      )}
      <div className="flex justify-between px-6 pt-4">
        <LinkWithoutPrefetch
          className="primary-link text-text-primary hover:text-brand-primary group inline-flex flex-row items-center gap-1"
          href="/profile/notification-settings"
        >
          <SettingsIcon
            className="fill-text-primary group-hover:fill-brand-primary"
            width={18}
            height={18}
          />
          <h4>{t('dashboard.notifications.manage_notifications.title')}</h4>
        </LinkWithoutPrefetch>
        <LinkWithoutPrefetch
          className="primary-link stroke-text-primary hover:stroke-brand-primary text-text-primary hover:text-brand-primary inline-flex flex-row items-center gap-3"
          href={`/notifications`}
        >
          <h4 className="capitalize">{t('dashboard.notifications.view_all')}</h4>
          <ThinArrowRightIcon />
        </LinkWithoutPrefetch>
      </div>
    </div>
  )
}
